module.exports = __webpack_public_path__ + "img/manpower.56c67038.jpg";